import intermind from '../../../index';
import { Plan } from '../types/plan.types';

export class PlanResource {
  async list(): Promise<Plan[]> {
    const { data } = await intermind.httpClient.get<Plan[]>('/billing/plans');
    return data;
  }
}
